import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'carbon-button',
  templateUrl: './carbon-button.component.html',
  styleUrls: ['./carbon-button.component.css']
})
export class CarbonButtonComponent {
  @Input() label: string = 'Button';
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() variant: 'primary' | 'secondary' | 'danger' = 'primary';
  @Input() disabled: boolean = false;
  @Input() fullWidth: boolean = false;
  @Input() loading: boolean = false; // Nova propriedade para loading
  @Output() clicked = new EventEmitter<Event>();

  onClick(event: Event) {
    if (!this.disabled && !this.loading) {
      this.clicked.emit(event);
    }
  }

  get buttonClass(): string {
    const baseClass = 'btn waves-effect waves-light';
    const variantClass = this.getVariantClass();
    const widthClass = this.fullWidth ? 'full-width' : '';

    return `${baseClass} ${variantClass} ${widthClass}`.trim();
  }

  private getVariantClass(): string {
    switch (this.variant) {
      case 'primary':
        return 'btn-primary';
      case 'secondary':
        return 'btn-secondary';
      case 'danger':
        return 'btn-danger';
      default:
        return 'btn-primary';
    }
  }
}
